import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.2465 13.1106C2.98976 11.6947 2.8614 10.9868 3.22613 10.507C3.25045 10.475 3.27617 10.4441 3.3032 10.4144C3.70869 9.96875 4.42629 9.96875 5.86147 9.96875H13.8085C15.2437 9.96875 15.9613 9.96875 16.3668 10.4144C16.3938 10.4441 16.4195 10.475 16.4439 10.507C16.8086 10.9868 16.6802 11.6947 16.4235 13.1106C16.0544 15.1465 15.8698 16.1644 15.1737 16.7897C15.1263 16.8323 15.0773 16.8733 15.027 16.9125C14.2889 17.4873 13.2571 17.4873 11.1936 17.4873H8.47645C6.41288 17.4873 5.38109 17.4873 4.64304 16.9125C4.5927 16.8733 4.54375 16.8323 4.49627 16.7897C3.80021 16.1644 3.61564 15.1465 3.2465 13.1106Z",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.11424 6.62647H12.4367C13.3314 6.62647 14.4523 6.49806 15.0267 7.33527C15.3027 7.73753 15.3027 8.84811 15.3027 9.96807M9.84373 6.62647L9.32183 5.60998C9.13866 5.25322 8.96731 4.82146 8.5928 4.62605C8.35123 4.5 8.06002 4.5 7.47761 4.5C6.11028 4.5 5.42662 4.5 4.9701 4.87285C4.20652 5.49646 4.38475 6.7764 4.38475 7.64485V9.96807",
      stroke: "white",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }